import React, { useState} from 'react'

const useHomeUsers = (initialState) => {
    const [valuesService, setValuesService] = useState(initialState)

    const _choiceService = (idService, nameService, priceService, durationService ) => {
        setValuesService(prevValues => ({
            ...prevValues,
            idService,
            nameService,
            priceService, 
            durationService
        }))
    }

    const _choiceStaff = (idStaff, surnameStaff, nameStaff) => {
        setValuesService(prevValues => ({
            ...prevValues,
            idStaff:idStaff,
            surnameStaff:surnameStaff,
            nameStaff:nameStaff
        }))
    }

    // SELECTION HEURE DE RÉSERVATION
    const _choiceHours = (date,dateShow,hours,idStaff,surnameStaff,nameStaff,idService,nameService,durationService,priceService) => {
        setValuesService(prevValues => ({
            ...prevValues,
            date:date,
            dateShow:dateShow,
            hours:hours,
            idStaff:idStaff,
            surnameStaff:surnameStaff,
            nameStaff:nameStaff,
            idService:idService,
            nameService:nameService,
            durationService:durationService,
            priceService:priceService
        }))
    }

    const _updateHours = () => {
        setValuesService(prev => ({
            ...prev, 
            date:'',
            dateShow:'',
            hours:'',
        }))
    }

    const _deleteState = () => {
        setValuesService(initialState)
    }

    return { _choiceService, valuesService, _choiceStaff, _choiceHours, _deleteState, _updateHours }
}

export default useHomeUsers



